/*------------------------------------*\
    accordion
\*------------------------------------*/
module.exports = function(){


    $('.js-accordion-heading').on('click', function(e) {
        $(this).toggleClass('is-active');
        $(this).next('.js-accordion-content').toggleClass('is-active');
        e.preventDefault();
    });


}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/blocks/accordion.js